import { useState, useEffect } from 'react';
import axios from '../axios';

const useAdminStatus = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [userType, setUserType] = useState(null);
    const [username, setUsername] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            const token = localStorage.getItem('access_token');
            const storedUsername = localStorage.getItem('username');
            if (!token || !storedUsername) {
                setIsAdmin(false);
                setUserType(null);
                return;
            }

            try {
                const response = await axios.get(`/profile/${storedUsername}/`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const user = response.data;
                console.log('User data fetched:', user); // Log user data for debugging
                setUsername(user.username);
                setIsAdmin(user.is_admin);
                console.log('isAdmin set to:', user.is_admin);
                if (user.student_id) {
                    setUserType('student');
                } else if (user.lecturer_id) {
                    setUserType('lecturer');
                } else {
                    setUserType(null);
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                setIsAdmin(false);
                setUserType(null);
            }
        };

        fetchUserData();
    }, []);

    return { isAdmin, userType, username };
};

export default useAdminStatus;
